export const DOCUMENT_MASK = '***********';
export const BIRTHDATE_MASK = '99/99/9999';
export const CEP_MASK = '99999-999';
export const CPF_MASK = '999.999.999-99';
export const CELLPHONE = '(99) 99999-9999';
export const CHASSI_MASK = '*** ***** * ** ******';
